import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function DialogProjectName({ open, onCancel, onSave }) {
  const [name, setName] = React.useState('');

  function handleChange(event) {
    setName(event.target.value);
  }

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">New Project</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please enter a name for your project:
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Project Name"
          type="text"
          value={name}
          onChange={handleChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={() => { onSave(name) }} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogProjectName;